import React, { useState, useEffect } from "react";
import { GiHamburgerMenu } from "react-icons/gi";

import { NavLink } from "react-router-dom";
import { getPrimaryNavLinks } from "../content";

const primaryNavLinks = getPrimaryNavLinks();

const Navbar = () => {
  const [showMediaIcons, setShowMediaIcons] = useState(false);
  const [scroll, setScroll] = useState(false);

  const closeMobileMenu = () => setShowMediaIcons(false);

  useEffect(() => {
    const onScroll = () => setScroll(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        className={
          scroll
            ? "header animated headroom--not-bottom headroom--not-top swingInX"
            : "header animated headroom--not-bottom swingInX headroom--top"
        }
      >
        <div className="container">
          <nav className="main-nav" aria-label="Primary">
            <div className="logo">
              <NavLink to="/" end>
                <img
                  className="mainlogo"
                  src="/img/logo.png"
                  alt="Plux Infosystems — home"
                />
              </NavLink>
            </div>

            <div
              className={
                showMediaIcons ? "menu-link mobile-menu-link" : "menu-link"
              }
            >
              <ul className="primary-menu-menu" id="primary-navigation">
                {primaryNavLinks.map((link) => (
                  <li
                    key={link.to}
                    className={
                      link.to === "/"
                        ? "menu-item-has-children"
                        : link.to === "/portfolio"
                          ? "has-megamenu menu-item-has-children"
                          : undefined
                    }
                  >
                    <NavLink to={link.to} end={link.to === "/"} onClick={closeMobileMenu}>
                      {link.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
            <div className="social-media">
              <div className="hamburger-menu">
                <button
                  type="button"
                  aria-expanded={showMediaIcons}
                  aria-controls="primary-navigation"
                  aria-label={
                    showMediaIcons ? "Close navigation menu" : "Open navigation menu"
                  }
                  onClick={() => setShowMediaIcons((open) => !open)}
                >
                  <GiHamburgerMenu aria-hidden />
                </button>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Navbar;
